import React from 'react';
import { TRANSLATIONS } from '../constants';
import { Globe } from 'lucide-react';

interface LanguageSelectorProps {
  currentLanguage: 'ko' | 'en';
  onLanguageChange: (language: 'ko' | 'en') => void;
  isDarkMode?: boolean;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  currentLanguage,
  onLanguageChange,
  isDarkMode = false,
}) => {
  const t = TRANSLATIONS[currentLanguage];

  return (
    <div className="space-y-3">
      <label className={`block text-sm font-medium ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
        <Globe className="w-4 h-4 inline mr-1" />
        {t.language}
      </label>
      <select
        value={currentLanguage}
        onChange={(e) => onLanguageChange(e.target.value as 'ko' | 'en')}
        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
          isDarkMode 
            ? 'bg-gray-700 border-gray-600 text-white' 
            : 'border-gray-300 bg-white text-gray-900'
        }`}
      >
        <option value="ko">{t.korean}</option>
        <option value="en">{t.english}</option>
      </select>
    </div>
  );
};